import React from 'react';
import { useBrandingStore } from '../../stores/branding.store';

const FRONTEND_VERSION = __APP_VERSION__;

export default function VersionFooter({ inverse = false }) {
  const { branding } = useBrandingStore();
  const backendVersion = branding._backend_version;
  const textColor = inverse ? 'var(--wfm-sidebar-subtitle)' : 'var(--wfm-text-light)';
  const dividerColor = inverse ? 'var(--wfm-sidebar-border)' : 'var(--wfm-border)';

  return (
    <div
      className="flex items-center justify-center flex-wrap gap-2.5 py-2 text-[11px] font-medium tracking-wide tabular-nums"
      style={{ color: textColor }}
    >
      <span>Frontend v{FRONTEND_VERSION}</span>
      {backendVersion && (
        <>
          <span aria-hidden="true" style={{ color: dividerColor }}>|</span>
          <span>Backend v{backendVersion}</span>
        </>
      )}
    </div>
  );
}
